import React from 'react';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

function ResellerDetails({ reseller }) {
    return (
        <Card title="Reseller details">
            <TableDetailsBody>
                <Row label="ID">{reseller.id}</Row>
                <Row label="Name">{reseller.name}</Row>
                <Row label="Last Name">{reseller.last_name}</Row>
                <Row label="Country">{reseller.country}</Row>
                <Row label="State">{reseller.state}</Row>
                <Row label="Phone country">{reseller.phone_country}</Row>
                <Row label="Phone">{reseller.phone}</Row>
                <Row label="Email">{reseller.email}</Row>
                <Row label="Reseller percent revenue">{reseller.reseller_percent_revenue}%</Row>
                <Row label="Count tickets">{reseller.lottery_tickets_count}</Row>
                <Row label="Sale sum">{reseller.sale_sum}</Row>
                <Row label="Sale sum in this month">{reseller.sale_sum_in_this_month}</Row>
                <Row label="Sale sum in last month">{reseller.sale_sum_in_last_month}</Row>
                <Row label="Revenue">{reseller.revenue}</Row>
                <Row label="Revenue in this month">{reseller.revenue_in_this_month}</Row>
                <Row label="Revenue in last month">{reseller.revenue_in_last_month}</Row>
                <Row label="Reseller debit">{reseller.reseller_debit_formatted}</Row>
                <Row label="Balance">{reseller.balance_formatted}</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default ResellerDetails;
